export const eventList = [
    {
        "image" : 'digimon',
        "eventName" : "Digimon",
        "eventSerialNo" : 1,
        
    },

    {
        "image" : 'codethon',
        "eventName" : "Codathon",
        "eventSerialNo" : 2,
        
    },
    
    {
        "image" : 'robonoid',
        "eventName" : "Robonoid",
        "eventSerialNo" : 3,
        
    },
    
    {
        "image" : 'hackathon',
        "eventName" : "Hackathon",
        "eventSerialNo" : 4,
        
    },
    
    {
        "image" : 'drawasaurus',
        "eventName" : "Drawsauras",
        "eventSerialNo" : 5,
        
    }
]